import React from 'react';
import { Table } from 'react-bootstrap';
import axios from './../../../constants/axios';

class TrialBalanceHome extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         trialBalance: {}
      };
   }

   componentDidMount() {
      axios.get('accounting/chartOfAccounts/trialBalance')
         .then((res) => {
            this.setState({
               trialBalance: res.data
            });
         });
   }


   render() {
      const { trialBalance } = this.state;
      return (
         <div>
            <h4>Trail Balance</h4>
            <h3>Balance Now: {trialBalance.total_balance}</h3>
            <Table striped bordered condensed >
               <thead>
               <tr>
                  <th>Particulars</th>
                  <th>Debit</th>
                  <th>Credit</th>
               </tr>

               </thead>
               <tbody>
               {trialBalance.accountBalance &&
               trialBalance.accountBalance.map((entry) => (
                  <tr key={entry.id} >
                     <td>{entry.name}</td>
                     <td>
                        {entry.balance > 0 ? entry.balance : null}
                     </td>
                     <td>
                        {entry.balance < 0 ? entry.balance : null}
                     </td>
                  </tr>
               ))
               }
               </tbody>
            </Table>
         </div>
      );
   }
}

TrialBalanceHome.propTypes = {};

export default TrialBalanceHome;



/** WEBPACK FOOTER **
 ** ./src/components/AccountingManagement/TrialBalance/TrialBalanceHome.js
 **/